// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { common } from '../../tokens/primitiveColors/common';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var accordionColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        active: {
            background: bg.state.selectedTransparent
        },
        // Figma defines no Default/Background card for Accordion — the summary
        // is transparent by default, not MUI Paper's default surface color.
        default: {
            background: common.transparent
        },
        border: bd.default,
        // text: secondary text color from Figma. Not wired in Accordion.tsx — the
        // secondary text is arbitrary consumer-composed content, not a MUI slot.
        // Consumers should reference it directly: accordionColors(mode).text
        text: tx.secondary,
        detailsText: tx.primary,
        title: tx.primary,
        disabled: {
            background: bg.state.disabled1,
            text: tx.disabled2,
            title: tx.disabled2
        },
        focus: {
            border: bd.actionBold
        },
        hover: {
            background: bg.state.hover0
        }
    };
};

//# sourceMappingURL=accordionColors.js.map